import { Box } from '@mui/material'
import { EditButton, SimpleShowLayout, TopToolbar, useRecordContext } from 'react-admin'

import AdvancedShow from '../../components/AdvancedShow'
import AdvancedTextField from '../../components/AdvancedTextField'
import DateTooltipField from '../../components/DateTooltipField'
import LockedForUpdateIcon from '../../components/icons/LockedForUpdateIcon'
import PeriodField from '../../components/PeriodField'
import ShowCardHeader from '../../components/ShowCardHeader'
import { SYSTEM_PERMISSION_UPDATE } from '../../config/permissions'
import { VEHICLE_UNAVAILABILITY_TYPES } from '../../config/vehicleUnavailabilities'
import { useIsFieldPermissionDenied, useResourcePermissions } from '../../domain/permissions'
import config from '../bookings/config'
import { ShowReference, ShowReferenceLinks, useShowStyles } from '../common/show'
import OrganisationField from '../organisations/field'
import { VehicleShowLayout } from '../vehicles/show'

const VehicleUnavailabilityShowLayout = () => {
  const showClasses = useShowStyles()
  return (
    <>
      <ShowCardHeader />
      <SimpleShowLayout sx={showClasses.fieldContainer}>
        <OrganisationField />
        <AdvancedTextField source="type" map={VEHICLE_UNAVAILABILITY_TYPES} />
        <PeriodField
          startedOnSource="started_on"
          endedOnSource="ended_on"
          label="resources.maintenances.fields.period"
          addTime
        />
        <DateTooltipField source="created_on" addTime />
      </SimpleShowLayout>
      <SimpleShowLayout sx={showClasses.fieldContainer}>
        <AdvancedTextField source="description" fallback="resources.maintenances.show.description.fallback" multiline />
      </SimpleShowLayout>
      <ShowReferenceLinks excluded={['vehicles']} />
    </>
  )
}

const VehicleUnavailabilityActions = () => {
  const [hasEdit] = useResourcePermissions(config.name, SYSTEM_PERMISSION_UPDATE)
  const record = useRecordContext()
  const canNotEditLockedResource = useIsFieldPermissionDenied({
    action: SYSTEM_PERMISSION_UPDATE,
    source: 'locked_for_update',
  })

  return hasEdit ? (
    <TopToolbar>
      {canNotEditLockedResource && record.locked_for_update === true ? <LockedForUpdateIcon /> : <EditButton />}
    </TopToolbar>
  ) : (
    <Box mt={2} />
  )
}

const VehicleUnavailabilityAside = () => (
  <ShowReference reference="vehicles" source="vehicle_id">
    <VehicleShowLayout excluded={['organisations']} hasRedirect />
  </ShowReference>
)

export default () => (
  <AdvancedShow actions={<VehicleUnavailabilityActions />} aside={<VehicleUnavailabilityAside />}>
    <VehicleUnavailabilityShowLayout />
  </AdvancedShow>
)
